/**
 * @module constants
 */

/**
 * interface of selectable fonts.
 */
export interface SelectableFonts {
  [x: string]: {
    id: number;
    name: string;
    url: string;
  }
}

/**
 * Selectable fonts (Enterprise only) 
 */
export const selectableFonts: SelectableFonts = {
  'Noto Sans TC': {
    id: 1,
    name: 'Noto Sans TC',
    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700&display=swap'
  },
  'Noto Serif TC': {
    id: 2,
    name: 'Noto Serif TC',
    url: 'https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@400;500;700&display=swap'
  },
  'Noto Sans JP': {
    id: 3,
    name: 'Noto Sans JP',
    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap'
  },
  'Roboto': {
    id: 4,
    name: 'Roboto',
    url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap'
  },
  'Open Sans': {
    id: 5,
    name: 'Open Sans',
    url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;700&display=swap'
  },
  'Lato': {
    id: 6,
    name: 'Lato',
    url: 'https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap'
  },
  'Poppins': {
    id: 7,
    name: 'Poppins',
    url: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap'
  },
  'Merriweather': {
    id: 8,
    name: 'Merriweather',
    url: 'https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&display=swap'
  },
  'Libre Baskerville': {
    id: 9,
    name: 'Libre Baskerville',
    url: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap'
  },
  'EB Garamond': {
    id: 10,
    name: 'EB Garamond',
    url: 'https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;500;700&display=swap'
  }
}
